import { TranslateService } from '@ngx-translate/core';
import { download, MessageService, AttachService } from 'elbuild-ui-lib-core';
import { Component, Input, OnInit } from '@angular/core';
import { DocTemplateService, DocTemplate } from 'toolbandi-ui-lib';
@Component({
	selector: 'app-doc-template-generate',
	templateUrl: './doc-template-generate.component.html',
	styleUrls: ['./doc-template-generate.component.scss']
})
export class DocTemplateGenerateComponent implements OnInit {

	@Input()
	entity: string;

	@Input()
	entityname: string = '';

	@Input()
	eid: number;

	@Input()
	tenderid: number;


	@Input()
	title: string;

	loading: boolean;
	templates: DocTemplate[];
	exporting: number;
	constructor(private doctemplateservice: DocTemplateService,
		private messageService: MessageService,
		private translateService: TranslateService) { }

	ngOnInit() {
		this.load();
	}


	load() {

		this.loading = true;

		if (this.entity) {
			this.doctemplateservice.searchTemplates(this.entity, this.tenderid).subscribe((data: DocTemplate[]) => {
				this.templates = data;
				this.loading = false;

			}, error => {
				this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
				this.loading = false;
			});
		}
	}


	generate(t: DocTemplate) {
		console.log('generate');
		if (t && this.eid) {
			this.exporting = t.id;
			this.doctemplateservice.generate(this.entity, t.id, this.eid).subscribe(result => {
				if (result) {
					let filename = t.name.toLocaleLowerCase().split(' ').slice(1).join('_') + '-' + this.entityname.toLocaleLowerCase().split(' ').join('_');
					filename += '_' + new Date().toLocaleDateString() + '-' + new Date().toLocaleTimeString();
					download(result, `${filename}.${t.type}`);
				}
				this.exporting = undefined;
			}, error => {
				this.exporting = undefined;
				this.messageService.sendError(error);
			});
		}
	}

}
